// extracted by mini-css-extract-plugin
export default {"nameInput":"siteAnnouncementForm_nameInput__nYXjy","durationFieldContent":"siteAnnouncementForm_durationFieldContent__EO5+y","countLimit":"siteAnnouncementForm_countLimit__een1D"};